import React from 'react';
import { LOGGIN } from '../constants/constants'
import { postData } from '../constants/Utils'
import dataUser from '../constants/userData'
import Swal from 'sweetalert2'

class Button extends React.Component {
    constructor(props){
        super(props);
        this.check=React.createRef();
        this.state={
           seller:this.props.seller,
           password:this.props.password,
           memberAccount:"0083212321",
           
           hideOverlay: true
        }
    }


     componentWillReceiveProps(newProps){
         this.setState({
            seller:newProps.seller,
            password:newProps.password
         })
     }


    onClickButonIngresar() {
        this.setState({
            hideOverlay:false
        })
        var token = "";
        var request={
            "user":this.state.seller,
            "password":this.state.password
        }
        if( this.state.seller!=="" && this.state.password!=="" ){
            postData(LOGGIN,request).then(result => {
                if(result==="error"){
                    this.setState({
                        hideOverlay:true
                    })
                    Swal({
                        title: 'Error',
                        text: 'Error inesperado.',
                        type: 'warning',
                        cancelButtonText: 'Aceptar'
                    })
                }else{
                    if(result.status===undefined || result.status===null){
                        dataUser.user=result.user;
                        dataUser.branchOffice= result.branchOffice;
                        dataUser.modules = result.modules;
                        dataUser.franchise = result.franchise;
                        
                        token = "canal=FR&userName="+result.user.email
                            +"&subsidiaryName="+result.branchOffice.name
                            +"&subsidiaryID="+result.branchOffice.id
                            +"&franchiseName="+result.franchise.name;
                        this.props.sellerAuth(true,token);
                    }else{
                        this.setState({
                            hideOverlay:true
                        })
                        Swal({
                            title: 'Error',
                            text: result.resultMessage,
                            type: 'warning',
                            cancelButtonText: 'Aceptar'
                        })
                    }
                }                        
            });
        }else{
            this.setState({
                hideOverlay:true
            })
            Swal({
                title: 'Error',
                text: "Usuario y contraseña obligatorio.",
                type: 'warning',
                cancelButtonText: 'Aceptar'
            })
        }
    }

    render() {
        return (
            <button className="col-12 btn btn-color-blue  p-10" onClick={this.onClickButonIngresar.bind(this)}>            
            <span hidden={this.state.hideOverlay} className="fa fa-spinner fa-spin"></span>
            <span hidden={!this.state.hideOverlay}>Ingresar</span>  
            </button>
        );
    }
}
export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js